import React from 'react';
import $ from 'jquery';
import { bindLinesForm } from '../common';
import { renderCheckboxList, columnWidth } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { withReferer } from 'plugins/contextual-back';
import Immutable from 'immutable';

require('plugins/are-you-sure');

export function list() {
  const from = '/pco-manager/demands/templates';

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/demands/templates/${id}`, from);
  const loadNextUrl = '/pco-manager/demands/templates/range.json';

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderColumns);
}

export function create() {
  const $form = $('form');
  bindLinesForm($form);
}

export function edit(ctx) {
  create();
}

const getTaskLabel = (activitySettings, taskType) => {
  if (activitySettings && activitySettings.annexTasks) {
    const annexTasks = Immutable.List(activitySettings.annexTasks);
    const task = annexTasks.find(t => taskType === t.taskType);

    if (task) {
      return task.name;
    }
  }
  return 'Inconnue';
};
function renderTaskType({ cellData }) {
  const activitySettings = __ACTIVITY_SETTINGS__;
  switch (cellData) {
    case 'RAT':
      return 'Dératisation';
    case 'INSECT':
      return 'Désinsectisation';
    case 'OTHER_PESTS':
      if (activitySettings && activitySettings.otherPests.name) {
        return activitySettings.otherPests.name;
      } else {
        return 'Inconnue';
      }
    case 'ANNEX_1':
      return getTaskLabel(activitySettings, 'ANNEX_1');
    case 'ANNEX_2':
      return getTaskLabel(activitySettings, 'ANNEX_2');
    default:
      return 'Inconnue';
  }
}

function renderColumns(width) {
  return [
    <Column
      key="name"
      dataKey="name"
      disableSort
      width={columnWidth(width, 10)}
      label="Nom"
    />,
    <Column
      key="task_type"
      dataKey="task_type"
      cellRenderer={renderTaskType}
      disableSort
      width={columnWidth(width, 6)}
      label="Type de tâche"
    />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/saas/demands/templates/index.js